<template>
  <div :style="paddingCalculator">
    <!-- :class="$store.getters['main/getBackgroundTone'](evenOdd)" -->

    <div class="text-cmponent container">
      <div class="text-component-title font-18 lh-30" v-if="!isInner">
        {{ _.get(contentData, "data.list[0].title") }}
      </div>
      <div
        class="text"
        v-html="_.get(contentData, 'data.list[0].content')"
      ></div>
    </div>
  </div>
</template>

<script>
import paddingCalculator from "@/mixins/paddingMixin";

export default {
  props: ["contentData", "evenOdd", "isInner"],
  mixins: [paddingCalculator],
  data() {
    return {
      pTopDesktop: 55,
      pBottomDesktop: 55
    };
  }
};
</script>

<style lang="scss">
.text-component-title {
  padding-bottom: 35px;
}
.text {
  opacity: 0.8;

  img {
    width: 100% !important;
    height: 600px !important;
    object-fit: cover;
    margin: 40px 0px;
    border-radius: 5px;

    @media (max-width: 766px) {
      height: 400px !important;
    }
  }
}
</style>
